<template>
  <div id="app">
    <Header></Header>
    <div id="body" style="isolation: isolate;">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer
  },
  watch: {
    "$i18n.locale": {
      immediate: true,
      handler() {
        document.title = this.$t("general.title");
      }
    }
  }
};
</script>

<style scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#body {
  flex-grow: 1;
}
</style>